import initialState from './initialState'
import {LOGIN, RECEIVE_TOKEN} from '../actions/actionTypes'

export default function auth(state = initialState.auth, action) {
	let newState
	switch (action.type) {
	case LOGIN:
		return action
	case RECEIVE_TOKEN:
		newState = action.auth
		return newState
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js